<template>
  <tr v-if="loading==true">
    <td>
      <router-link :to="'/binance/order/?symbol='+markets.id">{{markets.title}}</router-link>
    </td>
    <td>
      <Skeleton :count="1" />
    </td>
    <td>
      <Skeleton :count="1" />
    </td>
    <td>
      <Skeleton :count="1" />
    </td>
  </tr>
  <tr v-else>
    <td>
      <router-link :to="'/binance/order/?symbol='+markets.id">{{markets.title}}</router-link>
    </td>
    <td>
      <span class="text text-success" v-if="change=='up'">{{currentKline.data.c | nrOfDecimals}}</span>
      <span
        class="text text-danger"
        v-else-if="change=='down'"
      >{{currentKline.data.c | nrOfDecimals}}</span>
      <span class="text" v-else>{{currentKline.data.c | nrOfDecimals}}</span>
    </td>
    <td>{{currentKline.data.h | nrOfDecimals}} / {{currentKline.data.l | nrOfDecimals}}</td>
    <td>{{currentKline.data.q | formatCashMillion }}</td>
  </tr>
</template>
<script>
import { formatPrice, nrOfDecimals } from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

export default {
  components: { Skeleton },
  props: {
    markets: {
      type: Object,
      default: function() {
        return {
          id: "",
          title: ""
          // qrcode: ""
        };
      }
      // required: true
    }
  },
  data() {
    return {
      loading: false,
      change: "", //up, down
      changePercent: 0,
      loading: false,
      connection: null,
      change: 0,
      currentKline: {
        id: "",
        data: {
          e: "24hrMiniTicker", // Event type
          E: 0, // Event time
          s: "", // Symbol
          c: "", // Close price
          o: "", // Open price
          h: "", // High price
          l: "", // Low price
          v: "", // Total traded base asset volume
          q: "" // Total traded quote asset volume
        }
      }
    };
    //  isactive : true
  },
  beforeDestroy() {
    this.connection.close();
  },
  computed: {
    ...mapGetters(["getKlineDataById"]),
    klineData() {
      return this.$store.state.binance.klineData;
    }
  },
  filters: {
    nrOfDecimals: value => {
      if (!value) {
        return "";
      }
      return nrOfDecimals(value);
    },
    formatPrice: value => {
      if (!value) {
        return "";
      }
      return formatPrice(value);
    },
    preview: value => {
      if (!value) {
        return "";
      }
      return value.substring(0, 50) + "...";
    },
    formatCashMillion: n => {
      if (n < 1e3) return n;
      if (n >= 1e3 && n < 1e6) return formatPrice(+(n / 1e3).toFixed(4)) + "K";
      if (n >= 1e6) return formatPrice(+(n / 1e6).toFixed(4)) + "M";
    },
    formatCashThousand: n => {
      if (n < 1e3) return n;
      if (n >= 1e3) return +(n / 1e3).toFixed(4) + "K";
    }
  },
  async created() {
    this.loading = true;
    this.connection = new WebSocket(
      "wss://stream.binance.com:9443/ws/" + this.markets.id + "@miniTicker"
    );
    var that = this;
    this.connection.onmessage = function(event) {
      that.loading = false;
      that.actKlineData(that.markets.id, event.data);
    };

    this.connection.onclose = function(event) {
      console.log("onclose: ", event);
    };
    this.connection.onerror = function(event) {
      console.log("onerror: ", event);
    };
  },
  methods: {
    calculateChange(old, current) {
      let oldPrice = Number(old.data.c);
      let curPrice = Number(current.data.c);

      if (curPrice < oldPrice) {
        this.change = "down";
      } else if (curPrice > oldPrice) {
        this.change = "up";
      } else {
        this.change = "";
      }

      this.changePercent =
        Math.round(((curPrice - oldPrice) / oldPrice) * 100 * 100) / 100;

      //   if (
      //     typeof this.currentKline.id != "undefined" &&
      //     this.currentKline.id == this.markets.id
      //   ) {
      //     let data = this.currentKline.data;
      //     let firstNum = Number(data.k.h);
      //     let lastNum = Number(last);
      //   }
      //   this.change;
    },
    actKlineData(newId, newData) {
      // console.log("newId", newId);
      // console.log("newData", newData);

      var oldData = this.getKlineDataById(newId);
      if (typeof oldData == "undefined" && newData != null) {
        let param = {};
        param = {
          id: newId,
          data: JSON.parse(newData)
        };
        this.klineData.push(param);
        this.$store.dispatch("binance/actKlineData", this.klineData);
        oldData = param;
      } else {
        var index = this.klineData
          .map(x => {
            return x.id;
          })
          .indexOf(newId);
        if (index >= 0) {
          this.klineData.splice(index, 1);
        }

        let param = {};
        param = {
          id: newId,
          data: JSON.parse(newData)
        };
        this.klineData.push(param);
        this.$store.dispatch("binance/actKlineData", this.klineData);
      }

      this.currentKline = this.getKlineDataById(newId);

      this.calculateChange(oldData, this.currentKline);
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "spotmarkets"
};
</script>


// WEBPACK FOOTER //
// src/views/binance/spotmarkets.vue